import { TextField } from '@material-ui/core';
import {
  createStyles,
  Theme,
  WithStyles,
  withStyles
} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import React from 'react';

const styles = (theme: Theme) => createStyles({ root: { width: '4rem' } });

class Snooze extends React.Component<ISnoozeOwnProps> {
  public render() {
    const { classes } = this.props;
    return (
      <div>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Typography style={{ marginRight: '1rem' }}>
            Snooze Time(HH:MM)
          </Typography>
          <TextField
            id="snoozeTime"
            value={this.props.hrs}
            onChange={e => this.props.onChangeSnoozeTime(e, 'hrs')}
            type="number"
            InputLabelProps={{
              shrink: true
            }}
            className={classes.root}
            inputProps={{ min: 0 }}
            margin="none"
            placeholder={'HH'}
          />
          <Typography style={{ margin: '0 1rem' }}>:</Typography>
          <TextField
            id="snoozeTime"
            value={this.props.mins}
            onChange={e => this.props.onChangeSnoozeTime(e, 'min')}
            type="number"
            className={classes.root}
            InputLabelProps={{
              shrink: true
            }}
            inputProps={{ min: 0 }}
            margin="none"
            placeholder={'MM'}
          />
        </div>
        <Typography style={{ marginTop: '1rem' }}>
          {this.props.para
            ? this.props.para
            : `This will remove the selected row for the chosen duration. 
    The item will reappear in the Pod after snooze duration expires. Do you wish to continue?`}
        </Typography>
      </div>
    );
  }
}
interface ISnoozeOwnProps extends WithStyles<typeof styles> {
  hrs: number;
  mins: number;
  onChangeSnoozeTime: any;
  para: string;
}

export default withStyles(styles)(Snooze);
